import React from "react";
import ReactDOM from "react-dom";
import * as Sentry from "@sentry/react";
import { BrowserTracing } from "@sentry/tracing";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { APP_VERSION, DEPLOY_ENV } from "./version.js";

Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_DSN,
  integrations: [new BrowserTracing()],
  tracesSampleRate: process.env.REACT_APP_SENTRY_SAMPLE_RATE,
  // Both come from version.js so the channel the app displays and the channel
  // Sentry files issues under can never disagree. test and production report
  // into the same Sentry project, so `environment` is what separates them.
  environment: DEPLOY_ENV,
  release: APP_VERSION,
});

ReactDOM.render(
  <BrowserRouter>
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <App />
    </LocalizationProvider>
  </BrowserRouter>,
  document.getElementById("root")
);
